var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-rebrand"},[_c('a',{attrs:{"href":"https:www.hokocloud.com","target":"_blank"}},[_c('RemoteImg',{attrs:{"ready":_vm.ready,"src":_vm.logoLogin,"is-login":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }